import { Box } from "@mui/material";
import { authRoutes } from "app/router/auth/routes";
import { Header } from "app/router/private/Header";
import { getNavItems } from "app/router/private/navigation";
import { privateRoutes } from "app/router/private/routes";
import { Sidebar } from "app/router/private/Sidebar";
import { useAuth } from "modules/auth/useAuth";
import { buildAvatarImageUrl } from "modules/settings/api/avatarService";
import { useState } from "react";
import { Outlet, useLocation, useNavigate } from "react-router";
import { ThemeModeProvider } from "shared/theme/ThemeModeContext";

export function PrivateLayout() {
  const [isMobileNavigationOpen, setIsMobileNavigationOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const { signOut, user } = useAuth();
  const navigationItems = getNavItems(user?.role);
  const userAvatarSrc =
    user?.id && user.avatarUrl ? buildAvatarImageUrl(user.id, user.avatarUrl) : null;

  const handleSignOut = () => {
    signOut();
    navigate(authRoutes.login.path, { replace: true });
  };

  const handleOpenSettings = () => {
    navigate(privateRoutes.settings.path);
  };

  const handleNavigate = (path: string) => {
    setIsMobileNavigationOpen(false);

    if (location.pathname !== path) {
      navigate(path);
    }
  };

  return (
    <ThemeModeProvider>
      <Box
        sx={{
          minHeight: "100vh",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Header
          userName={user?.name ?? "Usuário"}
          userEmail={user?.email ?? "usuario@oxydtvm.com.br"}
          userAvatarSrc={userAvatarSrc}
          onOpenNavigation={() => setIsMobileNavigationOpen(true)}
          onOpenSettings={handleOpenSettings}
          onSignOut={handleSignOut}
        />

        <Box
          sx={{
            flex: 1,
            minHeight: 0,
            display: "grid",
            gridTemplateColumns: { xs: "1fr", lg: "280px minmax(0, 1fr)" },
          }}
        >
          <Sidebar
            currentPath={location.pathname}
            items={navigationItems}
            mobileOpen={isMobileNavigationOpen}
            onClose={() => setIsMobileNavigationOpen(false)}
            onNavigate={handleNavigate}
          />

          <Box component="main" sx={{ minWidth: 0 }}>
            <Outlet />
          </Box>
        </Box>
      </Box>
    </ThemeModeProvider>
  );
}
